import e from "react";
import { s as r } from "./styled-38387a7e.js";
function i({ width: t = "40px", ...c }) {
  return /* @__PURE__ */ e.createElement("svg", { width: t, viewBox: "0 0 132 58", ...c }, /* @__PURE__ */ e.createElement("g", { fill: "#ccc" }, /* @__PURE__ */ e.createElement("circle", { cx: "25", cy: "30", r: "13" }), /* @__PURE__ */ e.createElement("circle", { cx: "65", cy: "30", r: "13" }), /* @__PURE__ */ e.createElement("circle", { cx: "105", cy: "30", r: "13" })));
}
const o = r(i)(({ theme: t, color: c }) => ({
  circle: {
    animation: "load 1s infinite",
    fill: c || t.palette.common.white
  },
  "circle:nth-of-type(2)": {
    animationDelay: "0.2s"
  },
  "circle:nth-of-type(3)": {
    animationDelay: "0.4s"
  },
  "@keyframes load": {
    "0%": {
      opacity: 0
    },
    "50%": {
      opacity: 1
    },
    "100%": {
      opacity: 0
    }
  }
}));
function l(t) {
  return /* @__PURE__ */ e.createElement(o, { ...t });
}
export {
  l as M
};
